import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { ThroughProvider } from 'react-through'
import { IntlProvider } from 'react-intl';

import Store from './stores';
import { MuiThemeProvider } from './themes/default';
import ThemeCustom from './themes/custom';

ReactDOM.render(
  <Provider store={ Store }>
    <IntlProvider locale="en">
      <ThroughProvider>
        <MuiThemeProvider theme={ ThemeCustom }>
          <App />
        </MuiThemeProvider>
      </ThroughProvider>
    </IntlProvider>
  </Provider>
, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
